import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { portsEvent, profileTabs, profileTypeEnum } from "@components/templates/Profile/ProfileHeader/profile-enum";
import ProfileTabs from "@components/templates/Profile/ProfileTabs/ProfileTabs";
import { tabDetailsHandler } from "@redux/PortProfile/portProfileSlice";
import { getEventName, getUserActivePlan, renderTabs } from "@helpers/profileHelper";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { useLocation } from "react-router-dom";

const Tabs = () => {
  const [profileTabData, setProfileTabData] = useState(profileTabs);
  const { countDetails, tabDetails } = useSelector((state) => state.portProfile);
  const [shipmentDistributionLoader, setShipmentDistributionLoader] = useState(false);
  const { activeTabId } = tabDetails;
  const dispatch = useDispatch();
  const { loading } = countDetails;
  const { search: searchUrlParams, pathname } = useLocation();
  const dataSource = new URLSearchParams(searchUrlParams).get("dataSource");

  useEffect(() => {
    const filteredTabs = [];
    profileTabs.map((tab) => {
      if ((tab.countEnum && countDetails[tab.countEnum] > 0) || tab.isExcludeFilter) {
        filteredTabs.push({ ...tab, count: countDetails[tab.countEnum] });
      }
    });
    setProfileTabData(filteredTabs);
  }, [countDetails]);

  const handleTabClick = (id) => {
    trademoTrackingEvents(getEventName(profileTypeEnum.ports, portsEvent[id].tab), generateTrackingObject(dataSource, pathname, getUserActivePlan()));
    dispatch(
      tabDetailsHandler({
        ...tabDetails,
        activeTabId: id,
      })
    );
  };
  return profileTabData && profileTabData.length > 0 ? (
    <>
      <ProfileTabs handleTabClick={handleTabClick} activeTabId={activeTabId} loading={loading} profileTabData={profileTabData} setViewShipmentClick={() => null} setShipmentDistributionLoader={setShipmentDistributionLoader} shipmentDistributionLoader={shipmentDistributionLoader} />
      {renderTabs(activeTabId)}
    </>
  ) : null;
};

export default Tabs;
